/*! Copyright (c) Safe As Milk. All rights reserved. */
class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
        // Juicy S1: a busca nativa faz matching difuso ("crocs" trazia dezenas de produtos sem Crocs). Cada palavra vai
        // a Shopify como (title:X OR variants.sku:X OR body:X) e as palavras cruzam em AND. O evento formdata cobre o envio
        // do form e o new FormData() do dynamic-product-search.js; a caixa continua com o texto digitado
        // (main-search.liquid e seo-title.liquid remontam o texto). Revisar ao atualizar o Venue.
        if (this.form) this.form.addEventListener("formdata", (e => {
            const q = e.formData.get("q");
            if (q) e.formData.set("q", SearchForm.scopeQuery(q));
        }));
    }
    static scopeQuery(text) {
        const words = text.replace(/['\u2018\u2019]/g, "").replace(/["\u201c\u201d():*\\]/g, " ").split(/\s+/).filter((w => w && !/^(and|or|not)$/i.test(w)));
        return words.length ? words.map((w => `(title:${w} OR variants.sku:${w} OR body:${w})`)).join(" ") : text;
    }
    connectedCallback() {
        if (this.hasAttribute("add-recent-search-on-load")) this.addFormStateToRecentSearches();
    }
    static addRecentSearch(query, uri) {
        if (!query || !uri) return;
        const getUniqueListBy = (arr, key) => [ ...new Map(arr.map((item => [ item[key], item ]))).values() ];
        let recentSearches = [ {
            query: query,
            uri: uri
        } ];
        const recentSearchesStoredString = localStorage.getItem("recentSearches");
        if (recentSearchesStoredString) {
            const recentSearchesStored = JSON.parse(recentSearchesStoredString);
            const combinedSearches = [ ...recentSearchesStored, ...recentSearches ];
            recentSearches = getUniqueListBy(combinedSearches.reverse(), "query").reverse();
            if (recentSearches.length > 5) {
                recentSearches = recentSearches.slice(-5);
            }
        }
        localStorage.setItem("recentSearches", JSON.stringify(recentSearches));
        document.querySelectorAll("recent-searches").forEach((el => el.update()));
    }
    addFormStateToRecentSearches() {
        if (!this.form) return;
        const form = new FormData(this.form);
        const search = new URLSearchParams(form);
        const formAction = new URL(`${window.location.origin}${this.form.getAttribute("action")}`);
        const formActionOrigin = window.location.origin;
        const formActionPath = formAction.pathname;
        const formActionSearch = formAction.searchParams;
        const combinedSearch = new URLSearchParams({
            ...Object.fromEntries(formActionSearch),
            ...Object.fromEntries(search)
        });
        SearchForm.addRecentSearch(this.form.elements.q?.value, `${formActionOrigin}${formActionPath}?${combinedSearch.toString()}`);
    }
}

customElements.define("search-form", SearchForm);
//# sourceMappingURL=search-form.js.map
